<!-- Main Content -->
<div class="page-content">
  <!-- Header Section -->
  <div class="page-title-container">
    <app-breadcrumb></app-breadcrumb>
    <h1 class="page-title">Practice Areas</h1>
  </div>

  <mat-card class="details-card">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner diameter="32"></mat-spinner>
        <p>Loading practice area details...</p>
      </div>
    }

    <!-- Error State -->
    @if (error && !isLoading) {
      <div class="error-state">
        <i class="material-symbols-outlined error-icon">error</i>
        <h3>Error Loading Practice Area</h3>
        <p>{{ error }}</p>
        <button mat-raised-button color="primary" (click)="retry()">
          <mat-icon>refresh</mat-icon>
          Retry
        </button>
      </div>
    }

    <!-- Practice Area Details -->
    @if (practiceArea && !isLoading && !error) {
      <div class="practice-area-details">
        <div class="details-section">
          @if (!isEditingTitle) {
            <h2
              class="editable-title"
              (click)="startEditingTitle()"
              [class.has-custom-name]="
                practiceArea.originalDescription &&
                practiceArea.originalDescription !== practiceArea.description
              "
              title="Click to edit"
            >
              {{ practiceArea.description }}
              <mat-icon class="edit-icon">edit</mat-icon>
            </h2>
          } @else {
            <div class="title-editor">
              <!-- Bounded to match UpdateDisplayNameRequest's [MaxLength(200)] and the create
                   control, which already caps at the same value. Without it an over-length name
                   reaches the API, comes back as a validation 400, and is then flattened to generic
                   copy by the duplicate-only error branch in updateDisplayName. -->
              <input
                #titleInput
                class="title-input"
                [(ngModel)]="editedTitle"
                [maxlength]="maxNameLength"
                (blur)="saveTitle()"
                (keydown)="onTitleKeyDown($event)"
                [disabled]="isSavingTitle"
                placeholder="Enter practice area name..."
                autofocus
              />
              @if (isSavingTitle) {
                <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
              }
            </div>
          }

          @if (titleError) {
            <div class="inline-error-message">
              <mat-icon>error</mat-icon>
              <span>{{ titleError }}</span>
            </div>
          }

          <div class="metadata">
            <span class="id-section">
              <span class="label">ID:</span>
              <span class="value">{{ practiceArea.practiceCode }}</span>
            </span>
            @if (
              practiceArea.originalDescription &&
              practiceArea.originalDescription !== practiceArea.description
            ) {
              <span class="original-section">
                <span class="label">Original:</span>
                <span class="value">{{
                  practiceArea.originalDescription
                }}</span>
              </span>
            }
          </div>
        </div>
      </div>
    }
  </mat-card>

  <!-- Practice area resources (shared dual-list panel) -->
  @if (practiceArea && practiceAreaDataSource) {
    <app-resource-membership-panel
      [dataSource]="practiceAreaDataSource"
      title="Resources"
    ></app-resource-membership-panel>
  }
</div>
